import { TicketDTO, WhenAskForFriendlyName } from 'core/api';
import { Result } from 'core/infrastructure';
import { Command } from 'pos/common';

type Params = {
	when: WhenAskForFriendlyName,
	ticket: TicketDTO,
	setFriendlyName: (name: string) => Promise<void>
};

export default async function setFriendlyNameIfNeeded(params: Params) {
	const ticket = params.ticket;

	if (ticket.Location.AskForFriendlyName !== params.when)
		return Result.ok();

	if (ticket.FriendlyName.trim() !== '')
		return Result.ok();

	return await Command.execute('setTicketFriendlyName', { setFriendlyName: params.setFriendlyName, currentFriendlyName: ticket.FriendlyName });
}